import Vue, { AsyncComponent } from 'vue';
import Router, { RouteConfig, Route, NavigationGuard } from 'vue-router';
Vue.use(Router);

const routes: RouteConfig[] = [
  {
    name: 'Home',
    path: '/home',
    redirect: '/evaluation/CompetencyA/home'
  },
  {
    name: 'EvaluationIndex',
    path: '/evaluation/:testPaper',
    redirect: '/evaluation/:testPaper/home'
  },
  {
    name: 'EvaluationHome',
    path: '/evaluation/:testPaper/home',
    component: () => import('@/pages/evaluation/index.vue')
  },
  {
    name: 'Login',
    path: '/hwt/login',
    component: () => import('@/pages/common/login.vue')
  },
  {
    name: 'Article',
    path: '/article',
    component: () => import('@/pages/common/article.vue')
  },
  {
    name: 'HwtList',
    path: '/hwt/list',
    component: () => import('@/pages/evaluation/evaluation-list.vue')
  },
  {
    name: 'Result',
    path: '/result',
    redirect: '/evaluation/CompetencyA/result'
  },
  {
    name: 'EvaluationResult',
    path: '/evaluation/:testPaper/result',
    component: () => import('@/pages/evaluation/result.vue')
  },
  {
    name: 'EvaluationTransfer',
    path: '/evaluation/:testPaper/transfer',
    component: () => import('@/pages/evaluation/transfer.vue')
  },
  {
    name: 'AudioDetail',
    path: '/audioDetail',
    component: () => import('@/pages/evaluation/hewitt/audioDetail/index.vue'),
    children: []
  },
  {
    name: 'stopServer',
    path: '/stopServer',
    meta: {
      title: '服务维护'
    },
    component: () => import('@/pages/stopServer/index.vue')
  },
  {
    path: '*',
    redirect: '/home'
  },
  {
    name: 'stopServer',
    path: '/stopServer',
    meta: {
      title: '服务维护'
    },
    component: () => import('@/pages/stopServer/index.vue')
  }
];

const router: Router = new Router({
  mode: 'history',
  base: '/cooperation',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  var currentTime = new Date().getTime();
  // var startTime = new Date('2021/5/1 23:59:59').getTime();  // 测试时间
  var startTime = new Date('2021/5/3 22:00:00').getTime();
  var stopTime = new Date('2021/5/4 08:00:00').getTime();
  let isDevMode = localStorage.getItem('devMode');
  if (startTime < currentTime && currentTime < stopTime) {
    if (isDevMode == null || isDevMode === 'false') {
      if (to.name !== 'stopServer') {
        next({ name: 'stopServer' });
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
